import { getCampaignsFromCampaignManager } from '../../../providers/campaigns/campaignManagerProvider'
import { dispatch } from '../../../application/appStore'
import { changeLogo } from '../../../store/logo/logo.actions'
import {
  dispatchWidgetEmbed,
  findPositionToInjectCampaign,
  generateCampaignElement,
  getPostItems,
  postCategoriesAllowCampaigns,
  postHasAtLeastParagraphs,
  registerElementToViewabilityTracker,
} from './initCampaigns.utils'
import CampaignInjector from './CampaignInjector'

const COMMERCIAL_WIDGET_TABOOLA_FEED_PLACEHOLDER = 'commercialWidgetTaboolaFeedPlaceHolder'
const VIEWABILITY_LABEL = 'data-viewability_label'
const MINIMUM_NUMBER_OF_PARAGRAPHS = 3

const canInjectHeader = () => {
  return true
}

const canInjectBelowArticle = () => {
  return postCategoriesAllowCampaigns()
}

const canInjectInArticle = () => {
  const index = findPositionToInjectCampaign()
  return (
    postCategoriesAllowCampaigns() &&
    postHasAtLeastParagraphs(MINIMUM_NUMBER_OF_PARAGRAPHS) &&
    index !== -1
  )
}

const headerCampaignInjector = payload => {
  dispatch(changeLogo(payload.src))
}

const inArticleCampaignInjector = payload => {
  const campaignElement = generateCampaignElement(payload.embedCode)

  registerElementToViewabilityTracker(campaignElement.firstChild)
  dispatchWidgetEmbed(campaignElement.firstChild, VIEWABILITY_LABEL)

  const index = findPositionToInjectCampaign()
  const paragraph = getPostItems()[index]
  paragraph && paragraph.insertAdjacentElement('afterend', campaignElement)
}

const belowArticleCampaignInjector = payload => {
  const campaignElement = generateCampaignElement(payload.embedCode)

  registerElementToViewabilityTracker(campaignElement.firstChild)
  dispatchWidgetEmbed(campaignElement.firstChild, VIEWABILITY_LABEL)

  const taboolaPlaceholder = document.getElementsByClassName(
    COMMERCIAL_WIDGET_TABOOLA_FEED_PLACEHOLDER
  )[0]
  taboolaPlaceholder && taboolaPlaceholder.insertAdjacentElement('beforeend', campaignElement)
}

const POSITIONS = {
  HEADER: 'header',
  IN_ARTICLE: 'inArticle',
  BELOW_ARTICLE: 'belowArticle',
}

const campaignInjectors = {
  [POSITIONS.HEADER]: new CampaignInjector(headerCampaignInjector, canInjectHeader),
  [POSITIONS.IN_ARTICLE]: new CampaignInjector(inArticleCampaignInjector, canInjectInArticle),
  [POSITIONS.BELOW_ARTICLE]: new CampaignInjector(
    belowArticleCampaignInjector,
    canInjectBelowArticle
  ),
}

export const injectHeaderCampaigns = () => {
  return getCampaignsFromCampaignManager().then(campaigns => {
    campaigns.filter(campaign => campaign.position === POSITIONS.HEADER).forEach(campaign => {
      const { validate, inject } = campaignInjectors[campaign.position]
      if (validate()) {
        inject(campaign.payload)
      }
    })
  })
}

export const injectPostCampaigns = () => {
  return getCampaignsFromCampaignManager().then(campaigns => {
    campaigns.filter(campaign => campaign.position !== POSITIONS.HEADER).forEach(campaign => {
      const { validate, inject } = campaignInjectors[campaign.position]
      if (validate()) {
        inject(campaign.payload)
      }
    })
  })
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/initializers/campaigns/initCampaigns.js